import { Link } from "react-router";
import styled from "styled-components";
import { EventStatusProps } from "./types";

export const StyledPointsScoreboard = styled.div`
  container-type: inline-size;
`;

export const ScoreboardInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.space[4]};
  padding: ${(props) => props.theme.space[4]};
  border: ${(props) => props.theme.borders[2]};
  border-radius: ${(props) => props.theme.radii[3]};
  background-color: ${(props) => props.theme.colors.white4};

  @container (min-width: 700px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  @container (min-width: 900px) {
    gap: ${(props) => props.theme.space[6]};
  }
`;

export const ScoreboardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.space[3]};
  padding: ${(props) => props.theme.space[4]};
  border: ${(props) => props.theme.borders[2]};
  border-radius: ${(props) => props.theme.radii[3]};
  background-color: ${(props) => props.theme.colors.white4};

  @container (min-width: 700px) {
    flex: 0 0 55%;
    padding: ${(props) => props.theme.space[2]};
    padding-top: ${(props) => props.theme.space[3]};
  }
`;

export const ScoreboardMain = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${(props) => props.theme.space[3]};
  flex-wrap: wrap;

  @container (min-width: 700px) {
    flex-wrap: nowrap;
    gap: ${(props) => props.theme.space[2]};
  }
`;

export const ScoreboardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const EventStatus = styled.div<EventStatusProps>`
  font-family: ${(props) => props.theme.fonts.base};
  font-size: ${(props) => props.theme.fontSizes[4]};
  text-transform: uppercase;
  border-radius: ${(props) => props.theme.radii[2]};
  padding: 0.2rem ${(props) => props.theme.space[2]};
  background-color: ${(props) =>
    props.$isLive ? props.theme.colors.red : props.theme.colors.white};
  color: ${(props) =>
    props.$isLive ? props.theme.colors.white : props.theme.colors.black};
`;

export const ScoreboardHeading = styled.h2`
  margin: 0;
  font-size: ${(props) => props.theme.fontSizes[5]};
`;

export const ScoreboardUnit = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-around;
  gap: ${(props) => props.theme.space[2]};
  padding: ${(props) => props.theme.space[2]};
  border: ${(props) => props.theme.borders[2]};
  border-radius: ${(props) => props.theme.radii[3]};
  background-color: ${(props) => props.theme.colors.white4};
  text-align: center;
`;

export const ScoreboardUnitHeading = styled.h3`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${(props) => props.theme.space[1]};
  margin: 0;
  font-family: ${(props) => props.theme.fonts.bold};
  font-size: ${(props) => props.theme.fontSizes[3]};
`;

export const ScoreboardUnitValue = styled.div`
  font-family: ${(props) => props.theme.fonts.base};
  font-size: ${(props) => props.theme.fontSizes[9]};
`;

export const ArrowLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${(props) => props.theme.space[1]};
  text-decoration: none;
  /* Have to reset color because it's an anchor */
  color: ${(props) => props.theme.colors.white};
  svg {
    path {
      stroke: ${(props) => props.theme.colors.primary};
    }
  }

  &:hover {
    text-decoration: underline;
  }
`;

export const ScoreboardFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space[4]};

  @container (min-width: 700px) {
    flex: 0 0 40%;
  }
`;
